// Derives the stable cluster_id used as the audit-row partition key
// (`ACTION#<week>#<cluster_id>`) when an EM/TL actions a reaction-pattern
// cluster from the weekly digest. Must produce byte-identical output in
// the portal (which builds the action invocation) and the API (which
// reads back the audit row to surface actioned-status to the UI).
//
// `org` is required for correctness: without it, the same reviewer+week+
// tokens pattern across two orgs would collide on a single audit row,
// and the second org's action would 409 already_actioned. Callers must
// supply an org (use the selected/source org when the reviewer entry's
// own `org` field is absent in per-org views).

/** Identity tokens for a reaction cluster, fed into reactionClusterId(): the
 *  stable cluster_key when present (new digests), else the legacy keyword_tokens
 *  (rows written before clustering shipped). MUST be used identically by the
 *  portal (writes the action), the digest-reactions API (reads actioned state),
 *  and draft-context (resolves the cluster) — otherwise the audit-row id drifts
 *  and actions silently fail. */
export function clusterIdentityTokens(c: { cluster_key?: string; keyword_tokens: string[] }): string[] {
  return c.cluster_key ? [c.cluster_key] : c.keyword_tokens;
}

export function reactionClusterId(
  reviewer: string,
  week: string,
  tokens: string[],
  org: string,
): string {
  const orgPart = org ? `${org}_` : '';
  return `cl_${orgPart}${reviewer}_${week}_${tokens.join('-')}`
    .replace(/[^a-z0-9_-]/gi, '_')
    .slice(0, 80);
}
